/**
@ngdoc directive
@name ragSuitabilityFlag

@param {string=} status status (gray|red|amber|green), gray by default
@param {string} ajaxUrl ajax url parameter

@description
RAG suitability flag
Possible status:
- red
- amber
- green
- gray (not set - by default)
*/

(function() {
    'use strict';

    var ragFlag = function($timeout, ajaxCall) {
        return {
            restrict: "EA",
            replace: true,
            transclude: false,
            scope: true,
            bindToController: {
                ragStatus: "@status",
                ajaxUrl: "@"
            },
            controllerAs: "ctrl",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                var rags = ['gray', 'green', 'amber', 'red'];
                var ajaxRequest;
                _this.disabled = false;

                $timeout(function(){
                    _this.ragStatus = ( !angular.isDefined(_this.ragStatus) ||
                        (_this.ragStatus!='red' && _this.ragStatus!='amber' && _this.ragStatus!='green') ) ? 'gray' : _this.ragStatus;
                });

                _this.toggleRag = function(e){
                    _this.disabled = true;
                    if( angular.isDefined(ajaxRequest) && ajaxRequest.abort!==angular.noop ){
                        console.info('Early new request - aborting previous request.');
                        ajaxRequest.abort(); // cancel previous request
                    }

                    var index = rags.indexOf(_this.ragStatus);
                    index = (++index > rags.length-1) ? 0 : index;
                    _this.ragStatus = rags[index];

                    ajaxRequest = ajaxCall.getData(_this.ajaxUrl + "&ragStatus=" + _this.ragStatus);
                    ajaxRequest.then(
                        function(response){ _this.disabled = false; },
                        function(response){ _this.disabled = false; }
                    );
                }

            }],
            template: [
                '<a class="rag-suitability-flag rag-status-{{ctrl.ragStatus}}" href="javascript:void(0);" ng-click="!ctrl.disabled && ctrl.toggleRag();" title="Toggle suitability (RAG)">',
                    '<span class="glyphicon-flag glyphicon"></span>',
                '</a>'].join('')
        };
    }
    ragFlag.$inject = ['$timeout', 'ajaxCall'];
    angular.module('app').directive('ragFlag', ragFlag);

}());
